import React from 'react';
import { useFormState } from 'react-hook-form';
import { FieldData } from '../../../types/form.types';
import ContactReasonContent from './contact-reason.content';

interface ContactReasonProps {
  reasons: FieldData[];
}
const ContactReason: React.FunctionComponent<ContactReasonProps> = ({
  reasons
}) => {
  const { errors } = useFormState();
  if (!reasons[0]) return null;

  return <ContactReasonContent reasons={reasons} errors={errors} />;
};

export default ContactReason;
